import "core-js/modules/es.json.stringify.js";
export default {
  // 禁止web端屏幕缩放// 页面刷新的时候存储状态管理的数据，防止丢失
  created: function created() {
    console.log(this.$route, '当前路由');
    var meta = this.$route.meta.title;

    if (meta != '数据打印') {
      window.addEventListener("mousewheel", function (event) {
        if (event.ctrlKey === true || event.metaKey) {
          event.preventDefault();
        }
      }, {
        passive: false
      });
    } // 页面销毁后拿不到this数据，所以需要在window.onbeforeunload外面重新定义一个值来接受this


    var _store = this.$store.state;

    window.onbeforeunload = function () {
      sessionStorage.setItem('user', JSON.stringify(_store.power.data));
    };
  },
  // 页面created创建的时候存储状态管理里面的数据，mounted挂载的时候再重新赋值即可。
  mounted: function mounted() {
    var _store = this.$store.state;
    _store.power.data = JSON.parse(sessionStorage.getItem('user'));
    sessionStorage.removeItem('user');
  }
};